import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Upload, message, Card, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api,{imagepath} from '../api';

const { Title } = Typography;

const Settings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line
  }, []);

  const fetchSettings = async () => {
    const res = await api.get('/settings');
    console.log(res.data.data)
    if (res.data.success && res.data.data) {
      let logoList = [];
      if (res.data.data.logo) {
        logoList = [{
          uid: '-1',
          name: res.data.data.logo.split('/').pop(),
          status: 'done',
          url: `/storage/${res.data.data.logo}`,
        }];
        console.log(res.data)
        setLogoPreview(`${imagepath}storage/${res.data.data.logo}`);
      } else {
        setLogoPreview(null);
      }
      form.setFieldsValue({
        company_name: res.data.data.company_name || '',
        address: res.data.data.address || '',
        phone: res.data.data.phone || '',
        email: res.data.data.email || '',
        logo: logoList
      });
      console.log('Form values after setFieldsValue:', form.getFieldsValue());
    }
  };

  const handleLogoChange = info => {
    if (info.fileList && info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj || info.fileList[0];
      setLogoPreview(URL.createObjectURL(file));
    } else {
      setLogoPreview(null);
    }
  };

  const handleSubmit = async values => {
    setLoading(true);
    const formData = new FormData();
    formData.append('company_name', values.company_name || '');
    formData.append('address', values.address || '');
    formData.append('phone', values.phone || '');
    formData.append('email', values.email || '');
    if (values.logo && values.logo.length > 0 && values.logo[0].originFileObj) {
      formData.append('logo', values.logo[0].originFileObj);
    }
    const res = await api.post('/settings', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    setLoading(false);
    if (res.success) {
      message.success('Settings updated');
      fetchSettings();
    } else {
      message.error(res.message || 'Update failed');
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 600, margin: '0 auto' }}>
      <Title level={2}>Company Settings</Title>
      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="company_name"
            label="Company Name"
            rules={[{ required: true, message: 'Please enter company name' }]}
          >
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item name="address" label="Address">
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item name="phone" label="Phone">
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item name="email" label="Email">
            <Input type="email" autoComplete="off" />
          </Form.Item>

          <Form.Item
            name="logo"
            label="Logo"
            valuePropName="fileList"
            getValueFromEvent={e => (Array.isArray(e) ? e : e && e.fileList)}
          >
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={() => false}
              onChange={handleLogoChange}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>Select Logo</Button>
            </Upload>
            {logoPreview && (
              <img
                src={logoPreview}
                alt="Logo Preview"
                style={{ maxWidth: 120, marginTop: 8 }}
              />
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Settings
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings;
